module.exports = __webpack_public_path__ + "img/01_abe_07.bd77b20f.jpg";